import type { FC, RefObject } from 'react'
import { createRef, useState } from 'react'
import { createPopper } from '@popperjs/core'
import cn from 'classnames'
import SvgChevronDown from 'components/icons/ChevronDown'
import SvgChevronUp from 'components/icons/ChevronUp'
import { slugify } from 'helpers/slugfy'
import type { MenuProps, MenuItem } from '.'
import s from './dropdown.module.css'
import { Link } from '..'

const Dropdown: FC<MenuProps> = ({ label = '', items = null, onClickCallback }) => {
  const [dropdownPopoverShow, setDropdownPopoverShow] = useState(false)
  const btnDropdownRef = createRef()
  const popoverDropdownRef = createRef()

  function openDropdownPopover() {
    // @ts-ignore
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: 'bottom-start',
    })
    setDropdownPopoverShow(true)
  }

  function closeDropdownPopover() {
    setDropdownPopoverShow(false)
  }

  function toggle() {
    if (!dropdownPopoverShow) {
      openDropdownPopover()
    } else {
      closeDropdownPopover()
    }
  }

  if (!items) {
    return <></>
  }

  const click =
    onClickCallback ||
    // eslint-disable-next-line func-names
    function () {
      return null
    }

  return (
    <div className={s.root}>
      <div className={s.main}>
        <div className={s.content}>
          <button
            className={s.button}
            type="button"
            ref={btnDropdownRef as RefObject<HTMLButtonElement>}
            onClick={toggle}
          >
            <span>{label}</span>
            {dropdownPopoverShow ? <SvgChevronUp /> : <SvgChevronDown />}
          </button>
          <div
            ref={popoverDropdownRef as RefObject<HTMLDivElement>}
            className={cn(s.dropdown, dropdownPopoverShow ? s.open : s.hide)}
          >
            {items &&
              items.map((item: MenuItem) => (
                <Link
                  onClick={click}
                  key={`dropdown-${slugify(item.label as string)}`}
                  className={s.item}
                  href={item.href}
                >
                  <span>{item.label}</span>
                  {item?.right || <></>}
                </Link>
              ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Dropdown
